import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { sendEvent } from '../../utils';
import { Step1Module1Selectors } from '../../ducks/step1Module1';
import {
  MainStep,
  StepCircle,
  StepTitle,
  BackgroundCircle,
  LineProgressShared,
  MainStepWrapper,
  LineProgressContainer
} from './styles';
import { selectProductTaxesParams } from '../../ducks/step4Module2';
import { NO_RETRY_EVENT, track } from '../../utils/trackingEvent';

const stepsWithCustomPadding = [1, 3];

const Step = React.memo(function MemoStep({
  id,
  title = '',
  currentStep,
  isEnabled,
  handleRedirect,
  preventTransition,
  handleOpenModal
}) {
  const { productId } = useSelector(selectProductTaxesParams);
  const { operationTypeId, propertyTypeId, subPropertyTypeId, propertyTypes, propertySubTypes } = useSelector(
    Step1Module1Selectors.getInfoEvents
  );
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const currentModule = pathname.split('/').pop();

  const isCurrentStep = () => id === currentStep;

  const moduleNumber = step => {
    let number = '1';
    if (currentModule === 'caracteristicas' || currentModule === 'vistaprevia') {
      number = 3;
    } else if (currentModule === 'ubicacion' || currentModule === 'pago') {
      number = 2;
    } else if (currentModule === 'operacionypropiedad' || currentModule === 'seleccion') {
      number = 1;
    }
    const propertyObj = { list: propertyTypes, id: propertyTypeId };
    const subPropertyObj = { list: propertySubTypes, id: subPropertyTypeId };
    sendEvent(`${step} Module ${number}`, 'Boton del paso', operationTypeId, propertyObj, subPropertyObj);
  };

  const trackNotify = () => {
    if (currentStep === 4 && currentModule === 'error' && productId) {
      track(NO_RETRY_EVENT, productId);
    }
  };

  const handleClick = () => {
    if (isEnabled && !isCurrentStep()) {
      if (preventTransition) {
        handleOpenModal(id);
      } else {
        trackNotify();
        handleRedirect(id);
      }
      moduleNumber(t(title));
    }
  };

  const needCustomStyles = () => stepsWithCustomPadding.includes(id);

  return (
    <MainStepWrapper stepId={id} data-repa='stepper-wrapper'>
      <LineProgressContainer stepId={id} data-repa='stepper-progressLine'>
        <LineProgressShared enabledLine={id <= currentStep} />
      </LineProgressContainer>
      <MainStep customStyles={needCustomStyles()}>
        <BackgroundCircle currentStep={isCurrentStep()}>
          <StepCircle
            data-repa='stepper-wrapper-stepClickeable'
            onClick={handleClick}
            isCurrentStep={isCurrentStep()}
            isEnabled={isEnabled}
          >
            {id}
          </StepCircle>
        </BackgroundCircle>
        <StepTitle data-repa='stepper-wrapper-step-title' currentStep={isCurrentStep()} isEnabled={isEnabled}>
          {t(title)}
        </StepTitle>
      </MainStep>
    </MainStepWrapper>
  );
});

export { Step };
